import styles from './index.less';

import addUrl from '@/assets/home/add.png';
import closeIconUrl from '@/assets/home/close_icon.png';
import { FC } from 'react';
interface AddCommunityTipProps {
  btnClick: () => void;
}
const AddCommunityTip: FC<AddCommunityTipProps> = ({ btnClick }) => {
  return (
    <div className={styles['tip-container']}>
      <div className={styles.tip}>
        <img src={addUrl} alt="add" />
        <p>还没绑定房间吧，请立即前往吧！</p>
      </div>
      <div onClick={btnClick} className={styles.btn}>
        立即绑定
      </div>
      <div className={styles['action-btn']}>
        <img src={closeIconUrl} alt={'close'} />
      </div>
    </div>
  );
};

export default AddCommunityTip;
